import { useMutation } from "@tanstack/react-query";
import supabase from "@/supbase";

const insertContact = async (formData) => {
  const { data, error } = await supabase.from("contacts").insert([
    {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      country_code: formData.country_code || "+91",
      country_name: formData.country_name || "India",
      comment: formData.comment,
      looking_for: formData.looking_for || "",
    },
  ]);
  if (error) throw new Error(error.message);
  return data;
};

export function useContactMutation() {
  return useMutation({ mutationFn: insertContact });
}